import { type Tuple, type Middleware } from "@reduxjs/toolkit";
import { extraArgument } from "./extra-argument-builder";

type GetDefaultMiddleware = (options: {
  thunk: { extraArgument: typeof extraArgument };
}) => Tuple<Middleware[]>;

export const middleware = (getDefaultMiddleware: GetDefaultMiddleware) =>
  getDefaultMiddleware({ thunk: { extraArgument } });
